import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { promoteImages } from "../../utils/portalImages";
import { getSubscriptionPlan } from "../../api/SubscriptionApi";
import AuthenticatedLayout from "../../layouts/AuthenticatedLayout";
import TermsConditionsModal from "./components/TermsConditionsModal";
import VimeoPlayer from "../shared/components/VimeoPlayer";
import { fetchVideoBySlug } from "../../api/GeneralApi";
import { PROMOTE_VIDEO } from "../../utils/globalConstants";

function GettingStarted() {
  const location = useLocation();
  const path = location.pathname || "";
  const modalElementRef = useRef(null);
  const modalContainerRef = useRef(null);
  const [showPromoVideo, setShowPromoVideo] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [promoteVideoLink, setPromoteVideoLink] = useState("");
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);

  useEffect(() => {
    fetchPromoteVideo();
    fetchSubscriptionPlan();
  }, []);

  useEffect(() => {
    if (showPromoVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showPromoVideo]);

  const handleHidePromoVideo = () => {
    setShowPromoVideo(false);
  };

  const fetchSubscriptionPlan = () => {
    getSubscriptionPlan()
      .then((response) => {
        let plans = response.data.subscription_plans;
        setSubscriptionPlans(plans);
      })
      .catch((errors) => {
        console.log(errors);
      });
  };

  const fetchPromoteVideo = () => {
    fetchVideoBySlug(PROMOTE_VIDEO)
      .then((response) => {
        const videoLink = response.data.link;
        setPromoteVideoLink(videoLink);
      })
      .catch((error) => {
        console.error("Error fetching video", error);
      });
  };

  const toggleTermsModal = () => {
    setShowTermsModal(false);
    document.body.classList.remove("modal-open");
  };

  const handleShowPromoVideo = () => {
    setShowPromoVideo(true);
  };

  return (
    <>
      <div className="card">
        <div className="card-body px-4 mt-3">
          <div className="row">
            <div className="col-md-5 col-12 d-center">
              <img
                className="w-100"
                alt="How it work 1"
                src={promoteImages.how_it_work_img1}
              />
              <button
                onClick={handleShowPromoVideo}
                className="btn btn-info position-absolute how-it-work-img1-play-btn"
              >
                ▶
              </button>
            </div>
            <div className="col-md-7 col-12">
              <h3 className="text-xxl mb-0">Refer & Earn</h3>
              <ul>
                <li>30% Commission recurring monthly/annually</li>
                <li>High Converting sales offer & process</li>
                <li>
                  Sales funnels with complete end to end tracking and analytics
                </li>
              </ul>
              <div style={{ height: "500px" }}>
                <img
                  alt="How it work 2"
                  className="how-it-work-img2"
                  src={promoteImages.how_it_work_img2}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 col-12">
              <h3 className="text-xxl mb-0">Your Income Calculator</h3>
              <span className="text-md font-weight-bold">
                Earn 30% on Every Direct Referral Subscription — Here’s what you
                can make per member!
              </span>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="border-top-0 border-bottom-0 font-weight-bolder text-capitalize">
                        Member Plan
                      </th>
                      <th className="border-top-0 border-bottom-0 font-weight-bolder text-capitalize">
                        Status
                      </th>
                      <th className="border-top-0 border-bottom-0 font-weight-bolder text-capitalize">
                        Percentage
                      </th>
                      <th className="border-top-0 border-bottom-0 font-weight-bolder text-capitalize">
                        What you will Earn?
                      </th>
                    </tr>
                  </thead>
                  {subscriptionPlans.map((plan, index) => (
                    <tbody key={index} className="overflow-auto">
                      <tr>
                        <td className="border-0 text-xs">{plan.title}</td>
                        <td className="border-0 text-xs">Active</td>
                        <td className="border-0 text-xs">30%</td>
                        <td className="border-0 text-xs">
                          $ {(plan.amount * 0.3).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
            <div className="col-md-4 col-12 d-center">
              <img
                alt="How it work 3"
                className="h-100 w-100"
                src={promoteImages.how_it_work_img3}
              />
            </div>
          </div>
          <span
            className="font-weight-bold cursor-pointer"
            onClick={() => setShowTermsModal(true)}
          >
            Terms and Conditions Applied!
          </span>
          {showTermsModal && (
            <TermsConditionsModal
              path={path}
              toggleTermsModal={toggleTermsModal}
            />
          )}
        </div>
      </div>

      {/* Backdrop */}
      {showPromoVideo && (
        <div
          className="modal-backdrop fade show"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0)",
            zIndex: 99998,
          }}
        />
      )}

      {/* Modal */}
      <div
        id="video"
        tabIndex="-1"
        role="dialog"
        ref={modalContainerRef}
        className={`modal ${showPromoVideo ? "show" : ""}`}
        style={{
          display: showPromoVideo ? "block" : "none",
          zIndex: 99999,
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{
            maxWidth: "720px",
            margin: "1.75rem auto",
          }}
        >
          <div
            ref={modalElementRef}
            className="modal-content"
            style={{ backgroundColor: "white" }}
          >
            <div className="modal-header pb-0">
              <h5 className="modal-title">Welcome to Race to Freedom</h5>
              <button
                type="button"
                className="header-close-btn"
                onClick={handleHidePromoVideo}
              >
                <span aria-hidden="true" className="close-btn-span">
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body hide-scrollbar pt-0">
              <div
                className="wistia_responsive_padding"
                style={{ padding: "62.5% 0 0 0", position: "relative" }}
              >
                <div
                  style={{
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                  }}
                >
                  {promoteVideoLink && (
                    <VimeoPlayer
                      showPromoVideo={showPromoVideo}
                      videoId={promoteVideoLink}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthenticatedLayout(GettingStarted);
